const applePayHelper = {
    displayApplePay: smartPak.pageData && smartPak.pageData.displayApplePay,
    browserIsSafari: function () {
        const userAgent = navigator.userAgent;
        return userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1;
    },
    canMakeApplePayments: function () {
        return window.ApplePaySession && window.ApplePaySession.canMakePayments();
    },
    performMerchantValidation: async function (validationURL) {
        var body = 'ValidationUrl=' + validationURL;
        const response = await fetch('/api/ApplePay/ValidateMerchantAsync', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body
        });
        if (!response.ok) {
            throw new Error('Failed to perform merchant validation');
        }
        const session = await response.json();
        return session.content;
    }
};

export default applePayHelper;
